import React from 'react';

import { Tabs, TabsList, TabsTrigger } from '@dashboard/components/ui/tabs';

import SellerPagesPanel from '../components/email-templates/SellerPagesPanel';
import TemplatesPanel from '../components/email-templates/TemplatesPanel';
import useEmailTemplatesUrl from '../components/email-templates/useEmailTemplatesUrl';

const EmailTemplates = () => {
  const url = useEmailTemplatesUrl();

  return (
    <div className="min-w-0 space-y-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1>Email templates</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Preview every email we send, with sample data or with a seller page's real data.
          </p>
        </div>
        <Tabs value={url.mode} onValueChange={mode => url.update({ mode })}>
          <TabsList aria-label="Preview source">
            <TabsTrigger value="templates">Templates</TabsTrigger>
            <TabsTrigger value="pages">Seller pages</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {url.mode === 'pages' ? <SellerPagesPanel /> : <TemplatesPanel />}
    </div>
  );
};

export default EmailTemplates;
